var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row d-flex justify-content-center text-center pt-5 w-100 mx-0"},[_c('p',{staticClass:"font-weight-bold mb-0"},[_vm._v(_vm._s(_vm.calculatedDropTextOne))]),(_vm.uploadEnabled || _vm.multicorderEnabled)?_c('p',{staticClass:"ml-1 mb-0"},[_vm._v(" "+_vm._s(_vm.$t("ASSET_RESERVATION.TEXT.DROP_TEXT2"))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }